// src/components/Steps/AuthStep.js
import { useState } from 'react';
import Auth from '../Auth';

export default function AuthStep({ onLogin, adminPortal = false }) {
  const [lastName, setLastName] = useState('');
  const [userBadgeId, setUserBadgeId] = useState('');

  return (
    <div className='flex items-center justify-center h-screen bg-gray-100'>
      <Auth
        lastName={lastName}
        userBadgeId={userBadgeId}
        setLastName={setLastName}
        setUserBadgeId={setUserBadgeId}
        adminPortal={adminPortal}
        login={() => onLogin(lastName, userBadgeId)}
      />
    </div>
  );
}